$(document).ready(() => {
    /**
     * Adds 'is-active' class to primary buttons in order to
     * add a small click animation
     *
     * The jQuery selector is set to the main content to delegate event
     * handler, as some primary buttons are dynamically appended.
     */

    $('#maincontent')
    .on('click', '.pagebuilder-button-primary, .action.primary', (e) => {
        $(e.currentTarget)
            .addClass('is-active');
    })
    .on('mouseleave', '.pagebuilder-button-primary, .action.primary', (e) => {
        $(e.currentTarget)
            .removeClass('is-active');
    });
})
